module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgMThMMTQuNjg1NCAxMi43MDcxQzE1LjEwNDkgMTIuMzE2NiAxNS4xMDQ5IDExLjY4MzQgMTQuNjg1NCAxMS4yOTI5TDkgNiIgc3Ryb2tlPSIjMDkwQTBBIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/right-arrow.svg
// module id = 106
// module chunks = 117